<template>
    <div :class="[device_platform]" class="get-container">
        <div class="blacking" @click="hideSelf"></div>
        <div class="callback-request-container" @click.self="hideSelf">
            <div class="callback-request CKiForm">
                <div class="close" @click="hideSelf">X</div>
                <div class="callback-close">
                    <span v-html="c_text"></span>
                </div>
                <callback-form
                    v-on="$listeners"
                    :data="null"
                >
                    <p>УЗНАТЬ ПОДРОБНЕЕ</p>
                </callback-form>
            </div>
        </div>
    </div>
</template>

<script>
    import Mask from '../common/mask';
    import Mixin from '../common/mixin';
    import Keyup from '../common/keyup';
    import CallbackForm from './callback-form';

    export default {
        name: '',
        components: {CallbackForm},
        directives: {Mask, Keyup},
        mixins: [Mixin],
        props: ['custom_text'],
        data() {
            return {
                phone: '',
            }
        },
        computed: {
            c_text() {
                return this.custom_text || 'Закажите звонок и мы свяжемся с вами в ближайшее время'
            }
        },
        methods: {
            hideSelf() {
                let i = 1;
                this.$emit('close');
            }
        }
    }
</script>

<style scoped lang="scss">
    .mobile, .tablet {
        .callback-request {
            max-width: calc(100% - 25px);
        }
    }

    .callback-request-container {
        position: fixed;
        width: 100vw;
        top: 10vw;
        left: 0;
        z-index: 10;
    }

    .blacking {
        position: fixed;
        top: -100vh;
        left: -100vw;
        bottom: -100vw;
        right: -100vh;
        background: #000;
        opacity: 0.5;
        cursor: default;
        z-index: 10;
    }

    .callback-request {
        position: relative;
        margin: auto;
        z-index: 1200;
        width: 360px;
        background: #f1f1f1;
        padding: 40px 20px 15px;
        cursor: default;
        text-align: center;
        & > .close {
            position: absolute;
            font-weight: bold;
            font-size: 20px;
            top: 10px;
            right: 15px;
            cursor: pointer;
        }
        & > .callback-close {
            font-weight: bold;
            font-size: 20px;
            margin-bottom: 25px;
        }
        & > input {
            width: calc(100% - 20px);
            margin: 30px 10px 20px;
            height: 42px;
            text-align: center;
        }
        & > .send {
            font-weight: bold;
            text-transform: uppercase;
            font-size: 18px;

            width: calc(100% - 20px);
            margin: 0 10px;
            height: 42px;
            background-color: #ffcd0c;
            &:hover {
                background: #FFE100;
            }
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
        }
    }
</style>
